import React from 'react'
import Confetti from 'react-confetti'

import { CommonSvgContent } from "./CommonSvgContent"
import { ContentRoom4 } from "./ContentRoom4"
import { Balloon } from "./Balloon"
import { Help } from "./Help"

import "./../assets/scss/Room4.scss";


export const Room4 = (props) => {

  //const app = React.useRef();
  const steps = {
    "b_intro" : ["intro", "close"],
    "f_marge1" : null,
    "b_marge1a": ["centerl", "follow"],
    "b_marge1b": ["centerl", "close"],
    "f_cellulare" : null,
    "b_cellulare" : ["slide link", "close"],
    "risposta1": null,
    "f_marge2" : null, //aperturacassetto1
    "b_marge2a": ["centerl", "follow"],
    "b_marge2b": ["centerl", "close"],
    "f_schermo" : null,
    "b_schermo": ["auto link", "close"],
    "risposta2" : null,
    "b_marge3a": ["centerl", "follow"],
    "b_marge3b": ["centerl", "follow"],
    "b_marge3c": ["centerl", "close"],
    "b_exit" : ["exit", ""]

  };

  React.useEffect(() => {
    if(props.step == Object.keys(steps).indexOf("risposta1")) props.onNextHelp(1);
    if(props.step == (Object.keys(steps).indexOf("risposta1") + 1)) props.onNextHelp(0);
    if(props.step == Object.keys(steps).indexOf("risposta2")) props.onNextHelp(4);
    if(props.step == (Object.keys(steps).indexOf("risposta2") + 1)) props.onNextHelp(0);
  }, [props.step]);

  const handleLinkCellulare = (e) => {
    e.stopPropagation();
    //window.open('https://www.instagram.com/margherita_hacker/', '_blank', 'noopener,noreferrer');
    props.onChangeStep(Object.keys(steps).indexOf("b_cellulare"));
  }

  const fasce = [];
  const tvs = [];

  for (let i = 0; i < 16; i++) {
    fasce.push(<div className="fascia" key={i}><div className="top" /><svg className="bottomSvg" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 34.93 12.29"><path className="d" d="M17.34,.42c4.85,0,9.71,.01,14.56,0,2.74,0,3.22,.66,1.96,2.78-4.5,7.54-14.77,10.68-23.73,7.39C5.87,9.02,2.82,6.45,.9,2.82-.11,.91,.36,.4,2.78,.4c4.85,0,9.71,0,14.56,0,0,0,0,.01,0,.02Z"/></svg></div>);
  }

  for (let i = 0; i < 6; i++) {
    tvs.push(<div className="tv" key={i}><div className="screen" /></div>);
  }

    return(
      <div className="room4">

        <div className="muro">
          <div className="tubo">
            <ContentRoom4 stringToRet="tubo" />
          </div>
          <div className="bici">
            <ContentRoom4 stringToRet="bici" />
          </div>
        </div>

        <div className="parete">
          <div className="tenda">
            {fasce}
          </div>
          <div className="negozio">
            <div className="negozio_l">
              <div className="negozio_lover"></div>
              <div className="negozio_lt"></div>
              <div className="negozio_lb"></div>
            </div>
            <div className="negozio_r">
              <div className="negozio_r1">
                <div className="electronis">
                  <ContentRoom4 stringToRet="electronis" />
                </div>
              </div>
              <div className="negozio_r2">
                <div className="ripiano1" />
                <div className="ripiano2" />
                <div className="tvs">
                  {tvs}
                  <div className="maintv">

                  {(props.step <= Object.keys(steps).indexOf("risposta1")) &&

                    <div className="screennews">
                      <ContentRoom4 stringToRet="crash" />
                      <div className="textWrapper">
                        <p>Schiaparelli si è schiantato</p>
                      </div>
                      <div className="titleWrapper">
                        <h4>NEWS</h4>
                      </div>
                    </div>
                  }

                  {(props.step > Object.keys(steps).indexOf("risposta1")) &&

                    <button className={`screencode ${(props.step >= Object.keys(steps).indexOf("f_schermo")) ? "active" : "unactive"}`}
                            onClick={() => props.step >= Object.keys(steps).indexOf("f_schermo") ? props.onChangeStep(Object.keys(steps).indexOf("b_schermo")) : false } >
                      {(props.step == Object.keys(steps).indexOf("f_schermo")) &&
                        <CommonSvgContent stringToRet="click" />
                      }
                      {(props.step > Object.keys(steps).indexOf("f_schermo")) &&
                        <div className="clickable" />
                      }

                        <p><strong>ISTRUZIONI</strong><br />
                        01110011 01100011 01101000 01101001 01100001 01101110 01110100 01101111 00101110 00100000 01110011 01100111 01100001 01101110 01100011 01101001 01101111 00100000 01110000 01100001 01110010 01100001 01100011 01100001 01100100 01110101 01110100 01100101 00101110 00100000 01100011 01101111 01101101 01110000 01110101 01110100 01100101 01110010 00100000 01100100 01101001 00100000 01100010 01101111 01110010 01100100 01101111 00100000 01101001 01101110 00100000 01110100 01101001 01101100 01110100 00101110 00100000 01100001 01100011 01100011 01100101 01101110 01110011 01101001 01101111 01101110 01100101 00100000 01110010 01100101 01110100 01110010 01101111 01110010 01100001 01111010 01111010 01101001 00100000 01110000 01100101 01110010 00100000 00110011 00100000 01110011 01100101 01100011 01101111 01101110 01100100 01101001 00101110</p>
                      </button>
                    }

                  </div>
                </div>
              </div>
              <div className="negozio_r3" />
              <div className="negozio_r4" />
              <div className="negozio_rover"></div>

            </div>
          </div>
        </div>

        <div className="road">
          <ContentRoom4 stringToRet="road" />
        </div>

        <div className={`areaTelefono ${(props.step == Object.keys(steps).indexOf("risposta1") || props.step == Object.keys(steps).indexOf("risposta2")) ? "help3 ringing" : ""}`}>
          <div className="pianoUnder" />
          <div className="pianoOver">
            <div className="telefono">
              <CommonSvgContent stringToRet="telefono" />
            </div>

            <div className="helpsWrapper">
              <div className="helps">
                <button className="helpclick1 active" onClick={(e) => (props.helpstate >= 1 && props.helpstate <= 3) ? props.onAskForHelp(e, 1) :
                                                                      (props.helpstate >= 4 && props.helpstate <= 6) ? props.onAskForHelp(e, 4) : false }>1</button>
                <button className="helpclick2 active" onClick={(e) => (props.helpstate >= 1 && props.helpstate <= 3) ? props.onAskForHelp(e, 2) :
                                                                      (props.helpstate >= 4 && props.helpstate <= 6) ? props.onAskForHelp(e, 5) : false }>2</button>
                <button className="helpclick3 active" onClick={(e) => (props.helpstate >= 1 && props.helpstate <= 3) ? props.onAskForHelp(e, 3) :
                                                                      (props.helpstate >= 4 && props.helpstate <= 6) ? props.onAskForHelp(e, 6) : false }>3</button>
              </div>
            </div>
          </div>
        </div>

        {(props.step == Object.keys(steps).indexOf("risposta1")) &&
          <div className="risposta">
            {(props.answerfeedback == "wrong") && (<div className="wrong"><p>La password non è corretta</p></div>)}
            {(props.answerfeedback == "right") && (
              <>
                <p>BEN FATTO! Hai risolto l'enigma</p>
                <Confetti />
              </>
            )}

            {(props.answerfeedback !== "right") && (
              <div className="rispostaCont">
                <form onSubmit={(e) => props.onSubmitAnswer(e, "room4a", Object.keys(steps).indexOf("risposta1"))}>
                  <input type="text" placeholder="" value={props.answer} onChange={(e) => props.onChangeAnswer(e)} />
                  <input type="submit" value="OK" />
                </form>
                <p>3 caratteri senza spazi</p>
              </div>
            )}
          </div>
        }

        {(props.step == Object.keys(steps).indexOf("risposta2")) &&
          <div className="risposta multiple">
            {(props.answerfeedback == "wrong") && (<div className="wrong"><p>La password non è corretta</p></div>)}

            <div className="rispostaCont">
              <form onSubmit={(e) => props.onSubmitAnswer(e, "room4b", Object.keys(steps).indexOf("risposta2"))}>
                <label>Inserisci le istruzioni nella giusta sequenza</label>
                <label className="num">1.</label> <input type="text" value={props.answer} onChange={(e) => props.onChangeAnswer(e)} /><br />
                <label className="num" className="num">2.</label> <input type="text" value={props.answer2} onChange={(e) => props.onChangeAnswer(e,2)} /><br />
                <label className="num">3.</label> <input type="text" value={props.answer3} onChange={(e) => props.onChangeAnswer(e,3)} /><br />
                <label className="num">4.</label> <input type="text" value={props.answer4} onChange={(e) => props.onChangeAnswer(e,4)} />

                <input type="submit" value="OK" />
              </form>
            </div>
          </div>
        }

        <button
          className={`marge ${(props.step >= Object.keys(steps).indexOf("f_marge1") || props.step >= Object.keys(steps).indexOf("f_marge2")) ? "active" : "unactive"}`}
          onClick={() => props.step >= Object.keys(steps).indexOf("f_marge1") && props.step <= Object.keys(steps).indexOf("risposta1") ? props.onChangeStep(Object.keys(steps).indexOf("b_marge1a")) :
                         props.step >= Object.keys(steps).indexOf("f_marge2") && props.step <= Object.keys(steps).indexOf("risposta2") ? props.onChangeStep(Object.keys(steps).indexOf("b_marge2a")) : false } >
          {(props.step == Object.keys(steps).indexOf("f_marge1") ||
            props.step == Object.keys(steps).indexOf("f_marge2")) &&
            <CommonSvgContent stringToRet="click" />
          }

          {(props.step > Object.keys(steps).indexOf("f_marge1") && props.step <= Object.keys(steps).indexOf("risposta1") ||
            props.step > Object.keys(steps).indexOf("f_marge2") && props.step <= Object.keys(steps).indexOf("risposta2")) &&
            <div className="clickable" />
          }


          <div
            className={`phone ${(props.step >= Object.keys(steps).indexOf("f_cellulare") && props.step <= Object.keys(steps).indexOf("risposta1")) ? "active" : "unactive"}`}
            onClick={props.step >= Object.keys(steps).indexOf("f_cellulare") &&  props.step <= Object.keys(steps).indexOf("risposta1") ? handleLinkCellulare : () => false} >
            {(props.step == Object.keys(steps).indexOf("f_cellulare")) &&
              <CommonSvgContent stringToRet="click" />
            }

            {(props.step > Object.keys(steps).indexOf("f_cellulare") && props.step <= Object.keys(steps).indexOf("risposta1")) &&
              <div className="clickable" />
            }

            <CommonSvgContent stringToRet="phone" />
         </div>

          <CommonSvgContent stringToRet="marge" />
        </button>


        {(props.helpopen != 0) &&
          <Help room={props.room} clickon={`help${props.helpopen}`} onNextHelp={props.onNextHelp} />
        }

        {(Object.keys(steps).length > props.stepnow && Object.keys(steps)[props.stepnow].startsWith("b_")) &&
          <Balloon type={steps[Object.keys(steps)[props.stepnow]][0]} room={props.room} clickon={Object.keys(steps)[props.stepnow]} button={steps[Object.keys(steps)[props.stepnow]][1]} interaction={false} onChangeStep={props.onChangeStep} onChangeStep={props.onChangeStep} onChangeRoom={props.onChangeRoom} />
        }
      </div>
    )
}
